/**
 * Both versions of an illustration sit in the DOM and CSS shows one: `pj-on-light`
 * and `pj-on-dark` answer the theme, and the dark file carries the `-dark` suffix.
 */
const ILLUSTRATION_THEMES = [
  { className: 'pj-on-light', suffix: '' },
  { className: 'pj-on-dark', suffix: '-dark' }
] as const

export { ILLUSTRATION_THEMES }
